import { buildingQueryKey } from "ApiLayer/Building/queryBuildingModel";
import mutationUpdateCustomPlanName from "ApiLayer/CustomPlans/queryUpdateCustomPlanName";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import { showMutationAlert } from "utils/helpers";

export interface UpdateCustomPlanData {
    carbonReductionPlanId: string;
    name: string;
    buildingModelUid: string;
}

export const useUpdateCustomPlanName = () => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const queryClient = useQueryClient();

    return useMutation({
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        onSuccess: (_, variables) => {
            alert.success("Custom plan name updated.");

            queryClient.invalidateQueries([...buildingQueryKey, variables.buildingModelUid]);
        },
        mutationFn: async (data: UpdateCustomPlanData) => 
            mutationUpdateCustomPlanName(accessToken, {
              carbonReductionPlanId: data.carbonReductionPlanId,
              name: data.name,
        })
    });
}
